module.exports = __webpack_public_path__ + "static/media/BM_Dashboard.e813a7e7.svg";